import { ReactNode } from 'react';
import { DetailsListItem } from './DetailsListItem';
import { Stack, Typography } from '@mui/material';
import { ButtonLink } from '../Button/ButtonLink';
import { LinkOptions } from '@tanstack/react-router';
import { EditIconButton } from '../Button/EditIconButton';

export function EditDetailsListItem({
  label,
  value,
  loading,
  setLabel,
  editLabel,
  editLink,
}: {
  label: ReactNode;
  value: ReactNode;
  loading: boolean;
  setLabel: ReactNode;
  editLabel: ReactNode;
  editLink: LinkOptions;
}) {
  return (
    <DetailsListItem
      label={label}
      value={
        value ? (
          <Stack direction="row" spacing={1} alignItems="center">
            <EditIconButton title={editLabel} {...editLink} />
            <Typography variant="body1">{value}</Typography>
          </Stack>
        ) : (
          <ButtonLink variant="text" {...editLink}>
            {setLabel}
          </ButtonLink>
        )
      }
      loading={loading}
    />
  );
}
